import { Box, IconButton, useTheme, Avatar, Typography, Button, InputBase } from "@mui/material";
import { useContext, useState } from "react";
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; 
import config from '../../Config';

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const handleProfileClick = () => {
    setIsProfileOpen((prev) => !prev);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      const cookieName = cookie.split("=")[0].trim();
      document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    });

    setTimeout(() => {
      navigate("/");
    }, 100);
  };

  const userRole = sessionStorage.getItem('role');

  const profileBoxBgColor =
    theme.palette.mode === "dark"
      ? colors.primary[300]
      : colors?.white?.[100] || "#fff";

  const handleGeneratePassword = async (email, password, newPassword) => {
    const token = sessionStorage.getItem("adminToken"); 
    const apiUrl = `${config.apiBaseUrl}/admin/changePassword`;
    try {
      const response = await fetch(apiUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token, 
        },
        body: JSON.stringify({
          email,
          password,
          newPassword,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Password Changed Successfully!",
          text: data.message || "Your password has been updated.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "An error occurred while changing the password.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to change the password. Please try again later.",
      });
    }
  };

  const handleGeneratePasswordClick = () => {
    Swal.fire({
      title: 'Generate New Password',
      html: `
        <input type="email" id="email" class="swal2-input" placeholder="Enter your email address">
        <input type="password" id="password" class="swal2-input" placeholder="Current Password">
        <input type="password" id="newPassword" class="swal2-input" placeholder="New Password">
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
        const email = Swal.getPopup().querySelector('#email').value;
        const password = Swal.getPopup().querySelector('#password').value;
        const newPassword = Swal.getPopup().querySelector('#newPassword').value;

        if (!email || !password || !newPassword) {
          Swal.showValidationMessage('Please fill out all fields');
          return false;
        }

        return { email, password, newPassword };
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const { email, password, newPassword } = result.value;
        handleGeneratePassword(email, password, newPassword); 
      }
    });
  };


  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      <Box display="flex" backgroundColor={colors.primary[400]} borderRadius="3px" width="300px">
        <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton>
      </Box>

      <Box display="flex">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton onClick={handleProfileClick}>
          <PersonOutlinedIcon />
        </IconButton>
      </Box>

      {/* PROFILE BOX */}
      {isProfileOpen && (
        <Box
          sx={{
            position: "absolute",
            top: "50px",
            right: "16px",
            backgroundColor: profileBoxBgColor,
            boxShadow: 3,
            borderRadius: "8px",
            padding: "16px",
            zIndex: 10,
            width: "250px",
          }}
        >
          <Box display="flex" justifyContent="center" mb={1}>
            <Avatar
              sx={{
                bgcolor: theme.palette.mode === "dark" ? colors.greenAccent[400] : colors.primary[100],
              }}
            >
              <PersonOutlinedIcon />
            </Avatar>
          </Box>
          {/* <Typography variant="h6" color={colors.primary[700]} textAlign="center" mb={1}>
            {userName}
          </Typography> */}
          <Typography variant="body2" color={colors.grey[600]} textAlign="center" mb={2}>
            {userRole}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ width: "100%", mb: 1 }}
            onClick={handleGeneratePasswordClick} 
          >
            Generate New Password
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            sx={{ width: "100%" }}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default Topbar;
